/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { SysquePopupConfig } from '../models/sysque-popup-config';
import {
  AboutDialogCreator,
  ImportScheduleDialogCreator,
  PopupDialogCreator,
  CreateSystemCategoryDialogCreator,
  RenameSystemCategoryDialogCreator,
  DeleteSystemCategoryDialogCreator,
  PanelDataDialogCreator,
  ConfigurationLocationDialogCreator,
  PlaceCouplingDialogCreator,
  ConvertSystemDialogCreator,
  ApplyConduitIdDialogCreator,
  ApplyEquipmentIdDialogCreator,
  AddFittingsDialogCreator,
  ElectricalSettingsDialogCreator,
  AnnotationSettingsDialogCreator,
  CableTrayFamilyInformationDialogCreator,
  FieldFabFamilyInformationDialogCreator,
  SystemManagerDialogCreator,
  ProjectDataDialogCreator,
  ImportSystemsDialogCreator,
  DuplicateSystemCategoryDialogCreator,
  ConduitFamilyInformationDialogCreator,
  AssignProjectDialogCreator,
  JunctionBoxFamilyInformationDialogCreator,
  AddNewProjectParameterDialogCreator,
  FittingPrioritizationDialogCreator,
  HandAndMachineBendFamilyInformationDialogCreator,
  SysQueGaugeDialogCreator,
  KickHandAndMachineBendFamilyInformationDialogCreator,
  UserCustomContentFamilyInformationDialogCreator,
  DeviceEquipmentFamilyInformationDialogCreator,
  HangerSpecificationFamilyInformationDialogCreator
} from './popup-dialog.creator';
import { PopupDialog } from './popup-dialog.interface';
import { GlobalConstants } from '../constants/global-constants';

export function createDialog(sysquePopupConfig: SysquePopupConfig, dialogName: string): PopupDialog {
  switch (dialogName) {
    case GlobalConstants.ABOUT_ELECTRICAL_NAME_DIALOG:
      return create(new AboutDialogCreator(), sysquePopupConfig);
    case GlobalConstants.IMPORT_SCHEDULE_NAME_DIALOG:
      return create(new ImportScheduleDialogCreator(), sysquePopupConfig);
    case GlobalConstants.CREATE_SYSTEM_NAME_DIALOG:
      return create(new CreateSystemCategoryDialogCreator(), sysquePopupConfig, dialogName);
    case GlobalConstants.RENAME_SYSTEM_NAME_DIALOG:
      return create(new RenameSystemCategoryDialogCreator(), sysquePopupConfig, dialogName);
    case GlobalConstants.DELETE_SYSTEM_NAME_DIALOG:
      return create(new DeleteSystemCategoryDialogCreator(), sysquePopupConfig, dialogName);
    case GlobalConstants.DUPLICATE_SYSTEM_NAME_DIALOG:
      return create(new DuplicateSystemCategoryDialogCreator(), sysquePopupConfig, dialogName);
    case GlobalConstants.CREATE_CATEGORY_NAME_DIALOG:
      return create(new CreateSystemCategoryDialogCreator(), sysquePopupConfig, dialogName);
    case GlobalConstants.RENAME_CATEGORY_NAME_DIALOG:
      return create(new RenameSystemCategoryDialogCreator(), sysquePopupConfig, dialogName);
    case GlobalConstants.DELETE_CATEGORY_NAME_DIALOG:
      return create(new DeleteSystemCategoryDialogCreator(), sysquePopupConfig, dialogName);
    case GlobalConstants.APPLY_PANEL_DATA_NAME_DIALOG:
      return create(new PanelDataDialogCreator(), sysquePopupConfig);
    case GlobalConstants.CONFIGURATION_LOCATION_NAME_DIALOG:
      return create(new ConfigurationLocationDialogCreator(), sysquePopupConfig);
    case GlobalConstants.PLACE_COUPLING_DIALOG:
      return create(new PlaceCouplingDialogCreator(), sysquePopupConfig);
    case GlobalConstants.CONVERT_SYSTEM_DIALOG:
      return create(new ConvertSystemDialogCreator(), sysquePopupConfig);
    case GlobalConstants.APPLY_CONDUIT_ID_DIALOG:
      return create(new ApplyConduitIdDialogCreator(), sysquePopupConfig);
    case GlobalConstants.APPLY_EQUIPMENT_ID_DIALOG:
      return create(new ApplyEquipmentIdDialogCreator(), sysquePopupConfig);
    case GlobalConstants.ADD_FITTING_DIALOG:
      return create(new AddFittingsDialogCreator(), sysquePopupConfig);
    case GlobalConstants.ELECTRICAL_SETTINGS_DIALOG:
      return create(new ElectricalSettingsDialogCreator(), sysquePopupConfig);
    case GlobalConstants.ANNOTATION_SETTINGS_DIALOG:
      return create(new AnnotationSettingsDialogCreator(), sysquePopupConfig);
    case GlobalConstants.CABLE_TRAY_FAMILY_INFORMATION_DIALOG:
      return create(new CableTrayFamilyInformationDialogCreator(), sysquePopupConfig);
    case GlobalConstants.CONDUIT_FAMILY_INFORMATION_DIALOG:
      return create(new ConduitFamilyInformationDialogCreator(), sysquePopupConfig);
    case GlobalConstants.JUNCTION_BOX_FAMILY_INFORMATION_DIALOG:
      return create(new JunctionBoxFamilyInformationDialogCreator(), sysquePopupConfig);
    case GlobalConstants.FIELD_FAB_FAMILY_INFORMATION_DIALOG:
      return create(new FieldFabFamilyInformationDialogCreator(), sysquePopupConfig);
    case GlobalConstants.HAND_AND_MACHINE_BEND_FAMILY_INFORMATION_DIALOG:
      return create(new HandAndMachineBendFamilyInformationDialogCreator(), sysquePopupConfig);
    case GlobalConstants.KICK_HAND_AND_MACHINE_BEND_FAMILY_INFORMATION_DIALOG:
      return create(new KickHandAndMachineBendFamilyInformationDialogCreator(), sysquePopupConfig);
    case GlobalConstants.USER_CUSTOM_CONTENT_FAMILY_INFORMATION_DIALOG:
      return create(new UserCustomContentFamilyInformationDialogCreator(), sysquePopupConfig);
    case GlobalConstants.HANGER_SPECIFICATION_FAMILY_INFORMATION_DIALOG:
      return create(new HangerSpecificationFamilyInformationDialogCreator(), sysquePopupConfig);
    case GlobalConstants.APPLY_EQUIPMENT_DETAILS:
      return create(new DeviceEquipmentFamilyInformationDialogCreator(), sysquePopupConfig);
    case GlobalConstants.SYSTEM_MANAGER_DIALOG:
      return create(new SystemManagerDialogCreator(), sysquePopupConfig);
    case GlobalConstants.PROJECT_DATA_DIALOG:
      return create(new ProjectDataDialogCreator(), sysquePopupConfig);
    case GlobalConstants.ASSIGN_PROJECT_DIALOG:
      return create(new AssignProjectDialogCreator(), sysquePopupConfig);
    case GlobalConstants.IMPORT_SYSTEMS_DIALOG:
      return create(new ImportSystemsDialogCreator(), sysquePopupConfig);
    case GlobalConstants.ADD_NEW_PROJECT_PARAMETER_DIALOG:
      return create(new AddNewProjectParameterDialogCreator(), sysquePopupConfig);
    case GlobalConstants.CHANGE_PRIORITY_DIALOG:
      return create(new FittingPrioritizationDialogCreator(), sysquePopupConfig);
      case GlobalConstants.SYSQUE_GAUGE_DIALOG:
      return create(new SysQueGaugeDialogCreator(), sysquePopupConfig);

    default:
      return null;
  }
}
function create(creator: PopupDialogCreator, sysquePopupConfig: SysquePopupConfig, componentTitle?: string) {
  return creator.createDialog(sysquePopupConfig, componentTitle);
}
